<template>
  <div id="patrol-route-panel-con">
    <div class="patrol-route-panel" :class="{ 'plan-list-shows': showPanel }">
      <div class="blur-bg map-blur-panel"></div>
      <div class="header">{{ panelTypeLabel[panelType] }}</div>
      <div class="ruleAdd-dialog flex-auto">
        <el-scrollbar class="scroll-content" style="height: 100%">
          <el-form label-width="90px" :rules="panelType == 2 ? {} : rules" :model="formData" ref="form"
            :label-suffix="panelType == 2 ? '：' : ''" class="rule_conditions">
            <!-- 计划名称等信息 -->
            <div class="ele-planInfo">
              <el-form-item label="计划名称" prop="planName">
                <span v-if="panelType == 2">
                  {{ formData.planName }}
                </span>
                <el-input v-model="formData.planName" clearable v-else placeholder="请输入计划名称"></el-input>
              </el-form-item>
              <el-form-item label="画面数量" prop="windowNum">
                <span v-if="panelType == 2">
                  {{ formData.windowNum }}
                </span>
                <el-select placeholder="请选择画面数量" v-model.number="formData.windowNum" v-else style="width: 100%" disabled>
                  <el-option v-for="item in numList" :key="item" :value="item">
                  </el-option>
                </el-select>
                <!-- <span style="margin-left: 5px"> 个 </span> -->
              </el-form-item>
              <el-form-item label="打卡次数" prop="signTime">
                <span v-if="panelType == 2">
                  {{ formData.signTime }}
                </span>
                <el-input v-model.number="formData.signTime" placeholder="自动计算，无需手动输入" v-else disabled></el-input>
              </el-form-item>
              <el-form-item label="巡逻间隔" prop="playDuration">
                <span v-if="panelType == 2">
                  {{ formData.playDuration }}
                </span>
                <div class="flex-row" v-else>
                  <el-input v-model.number="formData.playDuration" placeholder="请输入巡逻间隔时间，单位秒"></el-input>
                  <!-- <span>秒</span> -->
                </div>
              </el-form-item>
              <el-form-item label="是否循环" prop="weatherToPoll">
                <span v-if="panelType == 2">
                  {{ formData.weatherToPoll == 1 ? "是" : "否" }}
                </span>
                <el-select v-model="formData.weatherToPoll" placeholder="请选择是否循环巡逻" v-else style="width: 100%">
                  <el-option v-for="item in roundStatus" :key="item.value" :value="item.value" :label="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="巡逻日期" prop="planDate" class="planTime">
                <!-- <div>
                <i class="xinghao iconfont-lunan icon-lunan-xinghao"></i>
                <label>巡逻日期</label>
              </div> -->

                <span v-if="panelType == 2" @click="chooseDate">
                  {{ formData.planDate.startDate }}~{{ formData.planDate.endDate }}
                  <i class="iconfont-lunan icon-lunan-rili"></i>
                </span>

                <div class="time-value-area flex-auto valign-center plan-date" @click="chooseDate" v-else>
                  <label :class="[
                    'time-label',
                    formData.planDate && formData.planDate.startDate
                      ? ''
                      : 'placeholder-text',
                  ]">
                    {{
                      formData.planDate && formData.planDate.startDate
                      ? formData.planDate.startDate
                      : "开始时间"
                    }}
                  </label>
                  <label class="split-label">至</label>
                  <label :class="[
                        'time-label',
                        formData.planDate && formData.planDate.endDate
                          ? ''
                          : 'placeholder-text',
                      ]">
                    {{
                      formData.planDate && formData.planDate.endDate
                      ? formData.planDate.endDate
                      : "结束时间"
                    }}
                  </label>
                  <i class="iconfont-lunan icon-lunan-rili"></i>
                </div>
              </el-form-item>
              <el-form-item label="执行要求" prop="remark">
                <span v-if="panelType == 2">
                  {{ formData.remark }}
                </span>
                <el-input type="textarea" placeholder="请输入执行要求" v-model="formData.remark" v-else></el-input>
              </el-form-item>
            </div>
            <div class="change-select">
              <div class="person-select">
                <span class="person-select-title">监控点</span>
                <span class="tip" v-if="panelType != 2 && showTip.selectedDeviceInfo">*请选择监控点</span>
              </div>
              <div style="padding: 0;">
                <el-table :data="selectedDeviceInfo" @row-click="handleTableClick">
                  <el-table-column type="index" width="50" label="序号"></el-table-column>
                  <el-table-column prop="cameraName" show-overflow-tooltip label="监控点名称"></el-table-column>
                  <el-table-column prop="isIndoor" label="位置" width="70">
                    <template slot-scope="scope">
                      {{ scope.row.isIndoor == 1 ? "室内" : "室外" }}</template>
                  </el-table-column>
                  <el-table-column label="操作" :width="panelType != 2 ? 120 : 50">
                    <template slot-scope="scope">
                      <el-button class="menu-btn" type="text" title="实况" @click="handlePlay(scope.row)"
                        icon="el-icon-video-play">
                      </el-button>
                      <span v-if="panelType != 2">
                        <el-button class="menu-btn" title="上移" :disabled="scope.$index == 0" type="text"
                          icon="el-icon-top" @click.stop="handleUp(scope.$index)"></el-button>
                        <el-button class="menu-btn" title="下移" type="text"
                          :disabled="scope.$index == selectedDeviceInfo.length - 1" icon="el-icon-bottom"
                          @click.stop="handleDown(scope.$index)"></el-button>
                        <el-button class="menu-btn" title="移除" :disabled="panelType == 2" type="text"
                          icon="el-icon-remove-outline" @click.stop="handleDel(scope.row)"></el-button>
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 选择负责人 -->
            <div style="height: 30%" class="person-change">
              <div class="person-select">
                <span class="person-select-title">选择负责人</span>
                <span class="tip" v-if="panelType != 2 && showTip.tableData">*请选择负责人</span>
              </div>
              <div class="person-btn" v-if="panelType != 2">
                <span @click="addPeople" class="pointer">
                  <i class="iconfont-lunan icon-lunan-jia-copy"></i>
                  添加
                </span>
                <div @click="collapsePerson" class="pointer">
                  <span v-if="personFoldIcon">
                    展开
                    <i v-if="personFoldIcon" class="iconfont-lunan icon-lunan-up"></i>
                  </span>
                  <span v-if="!personFoldIcon">
                    收起
                    <i v-if="!personFoldIcon" class="iconfont-lunan icon-lunan-down"></i>
                  </span>
                </div>
              </div>
              <!-- <person-select ref="personSelect"
                           :workType="2"
                           @getSelectedPerson="getSelectedPerson"></person-select> -->

              <div class="workGroup-list" v-show="workListShow">
                <el-table :data="tableData" stripe @selection-change="handleSelectionChange" ref="multipleTable">
                  <!-- <el-table-column type="selection"></el-table-column> -->
                  <el-table-column type="index" :label="$t('videoPatrol.label.No')" width="50">
                  </el-table-column>
                  <el-table-column prop="nickName" label="姓名"></el-table-column>
                  <el-table-column prop="accountNumber" label="账号"></el-table-column>
                </el-table>
              </div>
            </div>
          </el-form>
        </el-scrollbar>
      </div>
      <!-- 底部按钮 -->
      <div class="footer">
        <el-button @click="closeRight" type="info" :loading="btnLoading">{{
          btnLoading ? "提交中" : panelType == 2 ? "关闭" : "取消"
        }}</el-button>
        <el-button type="primary" @click="confirm" v-if="panelType != 2" :loading="btnLoading">{{ btnLoading ? "提交中" :
          "提交" }}</el-button>
      </div>
      <!-- <div class="plan-list-toolbars">
        <div
          style="-32px"
          class="map-blur-panel__expand-button right iconfont-lunan"
          :class="
            showPanel
              ? 'icon-lunan-shousuocaidan-copy'
              : 'icon-lunan-shousuocaidan'
          "
          @click="showPlanListPanel"
        ></div>
      </div> -->
      <calendar-component ref="calendarComp" @confirm="confirmCalendar"></calendar-component>
    </div>
    <el-dialog title="添加执行组" :visible.sync="dialogVisible" width="30%" v-dialogDrag class="work-group" append-to-body>
      <work-group-tree ref="workGroupTree" :multiCheck="true" @groupData="getGroupData"
        :showPercentage="false"></work-group-tree>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmPeople">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
import CalendarComponent from "../components/calendar-component";
import workGroupTree from "@src/modules/realTimeAlarm/components/workGroupTree";

export default {
  name: "patrol-route-panel",
  components: { CalendarComponent, workGroupTree },
  props: {
    panelType: {
      type: Number,
      default: 2,
    },
    selectedDeviceInfo: {
      type: Array,
      default: [],
    },
    showPanel: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    panelType: {
      handler(val) {
        this.$nextTick(() => {
          this.$refs["form"].rules && this.$refs["form"].clearValidate();
        });
      },
      immediate: true,
    },
    selectedDeviceInfo(newValue, oldValue) {
      this.formData.signTime = (Math.trunc(newValue.length / 3)) + 1
      if (newValue.length == 0 && oldValue.length > 0) {
        this.showTip.selectedDeviceInfo = true;
        return;
      }
      if (newValue.length > 0 && oldValue.length == 0) {
        this.showTip.selectedDeviceInfo = false;
        return;
      }
      this.showTip.selectedDeviceInfo = false;
    },
    tableData(newValue, oldValue) {
      if (newValue.length == 0 && oldValue.length > 0) {
        this.showTip.tableData = true;
        return;
      }
      if (newValue.length > 0 && oldValue.length == 0) {
        this.showTip.tableData = false;
        return;
      }
      this.showTip.tableData = false;
    },
  },
  data() {
    return {
      btnLoading: false,
      showTip: {
        tableData: false,
        selectedDeviceInfo: false,
      },
      dialogVisible: false,
      panelTypeLabel: ["新建巡逻计划", "修改巡逻计划", "巡逻计划详情"],
      // formData: {
      //   planName: "",
      //   planDate: {
      //     // 时间段类型，1-全天时段；2-自定义时段
      //     // 默认选中自定义时段
      //     rangType: 2,
      //     startDate: "",
      //     endDate: "",
      //     plannedPlayTime: [],
      //   },
      // },
      formData: {
        planName: "",
        planDate: {
          // 时间段类型，1-全天时段；2-自定义时段
          // 默认选中自定义时段
          rangType: 2,
          startDate: "",
          endDate: "",
          plannedPlayTime: [],
        },
        // 画面数量
        windowNum: 1,
        // 巡逻间隔
        playDuration: 10
      },
      // showPanel: true,
      numList: [1, 4, 9, 16],
      roundStatus: [
        { label: "是", value: 1 },
        { label: "否", value: 0 },
      ],
      rules: {
        planName: [
          {
            required: true,
            message: "请输入计划名称",
            trigger: ["change", "blur"],
          },
        ],
        playDuration: [
          {
            required: true,
            message: "请输入巡逻间隔时间",
            trigger: ["change", "blur"],
          },
        ],
        windowNum: [
          {
            required: true,
            message: "请选择窗格数量",
            trigger: ["change", "blur"],
          },
        ],
        signTime: [
          {
            required: true,
            // message: "请输入打卡次数",
            message: " ",
            trigger: ["change", "blur"],
          },
        ],
        weatherToPoll: [
          {
            required: true,
            message: "请选择是否循环巡逻",
            trigger: ["change", "blur"],
          },
        ],
        planDate: [
          {
            required: true,
            message: "请选择巡逻时间",
            trigger: ["change", "blur"],
          },
        ],
      },
      isEdit: false,
      openPanel: false,
      workListShow: true,
      personFoldIcon: false,
      tableData: [],
      multipleSelection: [],
      data: [],
    };
  },
  created() {
    this.openPanel = true;
  },
  mounted() { },
  methods: {
    handleTableClick(e) {
      let coord = [+e.longitude, +e.latitude];
      this.$map.MapInstance2D.setMapCenter(coord);
    },
    handleUp(index) {
      this.$emit("asc", index);
    },
    handleDown(index) {
      this.$emit("desc", index);
    },
    handleDel(row) {
      console.log("-----remove", row);
      this.$emit("toggleDevice", {
        id: row.cameraID,
        cameraName: row.cameraName,
        azimuth: row.azimuth || 5,
      });
    },
    //实况
    handlePlay(data) {
      console.log(data, "handlePlay");
      this.$app.AppInstance.handleMiniPlay({
        playType: "live",
        playTitle: data.cameraName, //摄像机名称
        playId: data.cameraID, //摄像机id
      });
    },
    //编辑打开修改面板
    open(planInfo) {
      console.log(planInfo);
      this.isEdit = true;
      let patrolPointTable = [];
      this.formData = {
        planName: "",
        planDate: {
          // 时间段类型，1-全天时段；2-自定义时段
          // 默认选中自定义时段
          rangType: 2,
          startDate: "",
          endDate: "",
          plannedPlayTime: [],
        },
        windowNum: 1,
        playDuration: 10
      };
      if (planInfo) {
        this.formData = planInfo;
        this.tableData = planInfo.responsibilityGroup;
      }
    },
    //关闭右侧面板
    closeRight() {
      this.openPanel = false;
      this.$emit("handleCancelPanel");
      this.tableData = [];
      this.showTip.tableData = false;
      this.showTip.selectedDeviceInfo = false;
      this.$refs["form"].resetFields();
    },
    // 收起面板
    showPlanListPanel() {
      this.showPanel = !this.showPanel;
    },
    chooseDate() {
      this.$nextTick(() => {
        this.$refs.calendarComp.show(
          this.formData.planDate,
          this.panelType == "2" ? true : false
        );
      });
    },
    confirmCalendar(data) {
      console.log(data, "===datatime");
      this.formData.planDate = data;
      this.$forceUpdate();
    },
    addPeople() {
      this.dialogVisible = true;
    },
    // 获取已选人员列表
    getSelectedPerson(list) {
      this.$log.debug("已选人员列表:", list);
      this.tableData = list;
      this.$nextTick(() => {
        this.toggleSelection(this.tableData);
      });
    },
    //责任人表格选中事件
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    //选择负责人
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.multipleSelection = this.multipleSelection.map((item) => {
        return item.accountNumber;
      });
      this.formData.choosePrincipal = this.multipleSelection;
    },
    // 收起责任人
    collapsePerson() {
      this.workListShow = !this.workListShow;
      this.personFoldIcon = !this.personFoldIcon;
    },
    getGroupData(data, name, name2) {
      // this.groupName = name2
      this.data = [...data];
      console.log("---this.data9999", this.data);
    },
    confirmPeople(data) {
      this.tableData = this.data.map((item) => {
        return {
          nickName: item.name,
          accountNumber: item.id,
          groupName: "鲁南新时代保卫大队",
          groupCode: item.parentId,
        };
      });
      this.$nextTick(() => {
        this.toggleSelection(this.tableData);
      });
      this.dialogVisible = false;
    },
    confirm() {
      // console.log(this.formData);
      this.showTip.selectedDeviceInfo =
        this.selectedDeviceInfo.length == 0 ? true : false;
      this.showTip.tableData = this.tableData.length == 0 ? true : false;
      this.formData.cameraList = this.selectedDeviceInfo;
      this.$refs.form.validate((result) => {
        if (result) {
          this.formData.startDate = this.formData.planDate.startDate;
          this.formData.endDate = this.formData.planDate.endDate;
          // delete this.formData.planDate;
          let url = "";
          let params = {};
          const addPatrolPlanVO = {
            planName: this.formData.planName,
            cameraList: this.formData.cameraList,
            startDate: this.formData.startDate,
            endDate: this.formData.endDate,
            plannedPlayTime: this.formData.planDate.plannedPlayTime,
            responsibilityGroup: this.tableData,
            // autostart: this.formData.autostart,
            weatherToPoll: this.formData.weatherToPoll,
            signDisplay: this.formData.signDisplay,
            signTime: this.formData.signTime,
            isAllTime: this.formData.planDate.rangType,
            windowNum: this.formData.windowNum,
            playDuration: this.formData.playDuration,
            remark: this.formData.remark,
          };
          if (this.panelType == "1") {
            url = api.videoTask.updatePlan;
            params = {
              planCode: this.formData.planCode,
              addPatrolPlanVO: addPatrolPlanVO,
            };
            delete params.addPatrolPlanVO.planCode;
          } else {
            url = api.videoTask.addPlan;
            params = addPatrolPlanVO;
          }
          this.btnLoading = true;
          this.$fetch(url, params).then((res) => {
            this.btnLoading = false;
            if (res.success) {
              this.closeRight();
              this.$parent.getPlanList();
              this.$message.success(res.msgContent);
            } else {
              this.$message.error(res.msgContent);
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.tip {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 10px;
  // color
}

.planTime {
  :deep .el-form-item__content {
    margin-left: 0 !important;
  }
}

.work-group {
  height: 700px;
  overflow: hidden;
}

.f16 {
  font-size: 16px;
}

.menu-btn {
  margin-left: 6px;

  :deep i {
    font-size: 16px;
  }
}

.time-value-area {
  height: 34px;
  line-height: 34px;
  @include set_theme_color(background-color, input-default-bg-color);
  @include set_theme_color(color, font-inactive-color);
  border-radius: 4px;
  // border: 1px solid #313841;
  border-image: initial;
  display: flex;
  margin-left: 10px;

  &.plan-date {
    cursor: pointer;
    padding: 0 10px;

    label {
      cursor: pointer;
    }

    .time-label {
      flex: 1;
      text-align: center;
      @include set_theme_color(color, font-default-color);

      &.placeholder-text {
        color: #757575;
      }
    }

    .split-label {
      margin: 0 10px;
    }
  }
}

#patrol-route-panel-con {
  position: absolute;
  top: 0px;
  display: flex;
  right: 0px;
  height: 100%;
  z-index: 2;

  .plan-list-shows {
    right: 0 !important;
    @include set_animation(all);
  }

  .patrol-route-panel {
    padding: 12px;
    width: 380px;
    height: 100%;
    position: absolute;
    top: 0;
    right: -450px;
    @include set_animation(all);

    // background: rgba(26, 31, 43, 0.9);
  }

  .iclass {
    color: #fff;
    cursor: pointer;
    @include set_theme_color(background-color, main-theme-color);
    padding: 8px 10px 7px;
  }

  .el-tag {
    color: #e1e1e1;
    // width: 120px;
    height: 28px;
    border-radius: 1px;
    margin-right: 16px;
    margin-bottom: 8px;
    background: rgba(64, 122, 238, 0.65);
    border-radius: 5px 5px 5px 5px;
    border: 1px solid #407aee;

    .el-tag__close {
      color: #fff;
    }
  }

  .pickerTime {
    height: 0;
    border: none;

    .ioc-picker {
      display: none;
    }

    // @include set_theme_color(background-color, table-header-bg-color);
    // @include set_theme_color(border-color, top-menu-border-color);
    // width: 242px;
  }

  .patrol-route-panel .el-table {
    // background-color: rgba(0, 0, 0, 0.01);
  }

  .el-tabs__nav-scroll {
    margin-left: 22px;
  }

  .patrol-route-panel .el-table--scrollable-x .el-table__body-wrapper {
    overflow-x: hidden;
    overflow-y: auto;
  }

  .line-distance {
    padding-right: 5px;
  }

  .pointTemplate {
    margin: 3px 0;
    width: 350px;
  }

  .pointTemplate_content {
    overflow: auto;
    height: 120px;
  }

  .header {
    border-left: 4px solid #407aee;
    position: relative;
    // width: 350px;
    line-height: 16px;
    text-align: left;
    padding-left: 10px;
    font-size: 16px;
    margin: 0px 10px 12px;
    // @include set_theme_color(background-color, table-header-bg-color);
  }

  .ele-planInfo {
    @include set_theme_color(background-color, map-panel-content);
    // background: rgba(26, 31, 43, 1);
    padding: 16px;
    margin-bottom: 15px;
    // height: calc(25% - 32px);
  }

  .operator-btn {
    display: inline-block;
    font-size: 12px;
    padding: 5px;
    cursor: pointer;
    width: 20px;
    line-height: 20px;
  }

  .templateList {
    line-height: 40px;
    border-bottom: 1px solid #212630;

    // background: #0d121c;
    .el-radio {
      color: #fff;
      width: 65%;
      margin-left: 18px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  .iconsetting {
    width: 10%;
    display: inline-block;
    text-align: center;
  }

  .person-btn {
    color: #9aa6c1;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    padding: 8px 15px;
    background-color: #fff;
  }

  .person-btn i {
    margin: 0 5px;
  }

  .change-select {
    // @include set_theme_color(background-color, dialog-content-bg-color);
    // background: rgba(26, 31, 43, 1);
    height: calc(42% - 15px);
    margin-bottom: 15px;
  }

  .person-change {
    @include set_theme_color(background-color, map-panel-content);
  }

  .person-select {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    padding: 12px 12px;
  }

  .person-select-title {
    border-left: 4px solid #407aee;
    position: relative;
    line-height: 16px;
    text-align: left;
    padding-left: 10px;
    font-size: 16px;
    margin: 0px 10px px 12px;
  }

  .workGroup-list {
    // margin-bottom: 12px;
    padding: 12px;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .ruleAdd-dialog {
    position: relative;
    overflow: hidden;
    height: calc(100% - 70px);
    // width: 426px;
  }

  .el-date-editor .el-range-separator {
    width: 9% !important;
    margin-right: 5%;
  }

  .el-table__body-wrapper {
    background: rgba(24, 31, 46, 0) !important;

    .el-table__empty-text {
      color: #fff;
    }
  }

  .el-table tbody tr {

    // background: rgba(0, 0, 0, 0) !important;
    &:hover {
      // background: #242b3d !important;
    }

    &:nth-child(even) {
      // background: #242b3d !important;
    }
  }

  .footer {
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
    position: absolute;
    width: 100%;
  }
}
</style>
